// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__ARzJK","pNone":"logo_pNone__oUpBT"};